import React, { FC, useEffect, useState } from 'react';
import { BoxV2 as Box, Flex } from 'portal-commons';
import SectionCard from './SectionCard';
import FieldBlock from './FieldBlock';
import {
  faBuildingCircleCheck,
  faCircleUser,
} from '@fortawesome/pro-regular-svg-icons';
import { CspProfile } from '@/types/user';
import { convertTimeWithTimezone } from '@/utils/time';

interface TabAccountProps {
  profile: CspProfile;
  countryName: string;
  currentPortalUsers?: number;
}

const TabAccount: FC<TabAccountProps> = ({
  profile,
  countryName,
  currentPortalUsers,
}) => {
  const [maxPortalUsers, setMaxPortalUsers] = useState('N/A');
  useEffect(() => {
    if (currentPortalUsers) {
      setMaxPortalUsers(`${currentPortalUsers} / ${profile?.maxPortalUsers}`);
    }
  }, [currentPortalUsers, profile?.maxPortalUsers]);

  return (
    <Flex sx={{ columnGap: 24, mt: 10 }} data-testid="tabAccountContainer">
      <SectionCard
        icon={faBuildingCircleCheck}
        title="CSP Details"
        dataTestId="cspDetailsSection"
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            rowGap: '16px',
            columnGap: '16px',
          }}
        >
          <FieldBlock
            label="Address / Street"
            value={profile?.street}
            dataTestId="addressStreet"
          />
          <FieldBlock label="City" value={profile?.city} dataTestId="city" />
          <FieldBlock
            label="Website"
            value={profile?.website}
            dataTestId="website"
          />
          <FieldBlock label="State" value={profile?.state} dataTestId="state" />
          <FieldBlock
            label="Zip Code"
            value={profile?.postalCode}
            dataTestId="postalCode"
          />
          <FieldBlock label="Tax ID" value={profile?.ein} dataTestId="taxId" />
          <FieldBlock
            label="Country"
            value={countryName}
            dataTestId="country"
          />
          <FieldBlock
            label="Stock Symbol"
            value={profile?.stockSymbol}
            dataTestId="stockSymbol"
          />
          <FieldBlock
            label="Stock Exchange"
            value={profile?.stockExchange}
            dataTestId="stockExchange"
          />
          <FieldBlock
            label="Registered On"
            value={convertTimeWithTimezone(
              profile.createDate,
              undefined,
              'MM/DD/YYYY'
            )}
            dataTestId="registeredOn"
          />
        </Box>
      </SectionCard>
      <SectionCard
        title="Account Usage"
        icon={faCircleUser}
        dataTestId="accountUsageSection"
      >
        <Box sx={{ mb: 16 }}>
          Maximums are adjustable upon request without cost. Portal users can be
          added in increments of 10 with an associated cost. Please reach out to{' '}
          <a
            href="mailto:support@campaignregistry.com"
            style={{ textDecoration: 'underline', color: '#0091B3' }}
          >
            support@campaignregistry.com
          </a>{' '}
          for information.
        </Box>
        <FieldBlock
          label="Max Portal Users"
          value={maxPortalUsers}
          dataTestId="maxPortalUsers"
        />
      </SectionCard>
    </Flex>
  );
};

export default TabAccount;
